module.exports = "/virtual-football-league/img/video/clubs/spain/real-madrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/spain/real-madrid.png
// module id = 356
// module chunks = 4